

    $("body").on("click",".test_packages_upload_btn",function(e){
        $('#test_packages_upload_form').ajaxForm(options);
      });

      var options = {
        complete: function(response)
        {
            fnUpdateAllDataTables();
            Swal.fire({
                icon: response.responseJSON.status,
                title: response.responseJSON.message,
            });
        }
      };

    $(document).on('change','#test_packages_upload_input',function(e){
        $('#test_packages_upload_filename').text(e.target.files[0].name);
    });


if(ExURL.testpackages()){
    if(ExURL.jtree()){
        $('#menuchka').jstree({
            "plugins": ["search"],
            "core": {
                "themes":{
                    "icons":false,
                    "dots": false,
                }
            }
        }).on('open_node.jstree', function (e, data) { data.instance.set_icon(data.node, "icon md-minus");
        }).on('close_node.jstree', function (e, data) { data.instance.set_icon(data.node, "icon md-plus");
        });
        $('#menuchka').jstree(true).select_node('mn1');
    }


    $('.test_packages_upload').on('click', function(){
        Swal.fire({
            title:'Загрузить курс',
            html:`
            <form id = "test_packages_upload_form" action="/uploadpackage" enctype="multipart/form-data" method="POST">
            <input type="file" name="package" class="form-control">
            <button class="btn btn-success test_packages_upload_btn" type="submit">Upload</button>
          </form>
            `,
        });

    });

    $("body").on("click",".test_packages_upload_btn",function(e){
        $('#test_packages_upload_form').ajaxForm(options);
      });

      var options = {
        complete: function(response)
        {
            Swal.fire({
                icon: response.responseJSON.status,
                title: response.responseJSON.message,
            });
        }
      };


    var SCORM_API = window.API_1484_11;

    window.API_1484_11.on("Initialize", function() {
        console.log('SCORM API_1484_11 Initialize!');
        SCORM_API = window.API_1484_11;
    });
    window.API.on("LMSInitialize", function() {
        console.log('SCORM API LMSInitialize!');
        SCORM_API = window.API_1484_11;
    });
    SCORM_API.on("Commit", function() {
        console.log('SCORM API Commit!');
    });
    SCORM_API.on("Terminate", function() {
        console.log('SCORM API Terminate!');
    });

    SCORM_API.on("SetValue", function(CMIElement, Value) {
        // console.log(CMIElement);
        // console.log(Value);
    });

    SCORM_API.on("SetValue.cmi.completion_status", function(CMIElement, Value) {
        if (Value == "completed" && CMIElement == "cmi.completion_status") {
           // if (typeof(SCORM_API.cmi.score.raw) !== 'string') {
             //   Swal.fire({
               //     type: 'warning',
                 //   title: 'Непредвиденная ошибка!',
                   // footer: '<a id = "MailSupport" href = "javascript:void(0);">Написать в службу поддержки</a>',
              //  });
           // } else {
                Swal.fire({
                    title: 'Обрабатываем результаты, ожидайте',
                    allowOutsideClick:false,
                    allowEscapeKey:false,
                    heightAuto:false,
                    onBeforeOpen: () => {
                        Swal.showLoading()
                    }
                });

		let my_result = (!SCORM_API.cmi.score.max)?100:(SCORM_API.cmi.score.max/(SCORM_API.cmi.score.max/100));
                $.post('/tests_result',{
                    result:my_result,
                    topic_id:$('#testpackageiframe').attr('topic_id'),
                    // exam:'',
                    is_exam:'',
			theme_id:$('#testpackageiframe').attr('theme_id'),
                    training:$('#testpackageiframe').attr('theme_id'),
                    is_testpackages:1,
                    topic_title:$('#testpackageiframe').attr('theme_title'),
                },function(data){
                    Swal.fire({
                        icon: data.status,
                        title: 'Ваш результат: ' + my_result + '%',
                        text: data.message,
                        footer: '<a id = "MailSupport" href = "javascript:void(0);">Написать в службу поддержки</a>',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        heightAuto: false,
                    }).then(() => {
                        SCORM_API.Terminate('true');
			if(data.goto != 0){
                            window.location.href = data.goto;
                        }
                    });
                });
 //           }
        }
    });
}
